<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-button v-if="resource.idEstatusSolicitud != 3 && resource.idEstatusSolicitud != 4"
      @click="putCambiarEstatusSolicitud(data.item.idSolicitudEtapa, resource.idEstatusSolicitud)"
      variant="outline-warning"
      >Cambiar a estatus Sin Toma de Hdx</b-button>
  </div>
</template>

<script>
export default {
  name: "BandejaCambiarEstatusEnEsperaComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    putCambiarEstatusSolicitud(idSolicitudEtapa, idEstatusSolicitud) {
      var params = {
        idSolicitudEtapa: idSolicitudEtapa,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
        idEstatus : 4
      };

      this.$http
        .put(
          this.$api +
            "hallazgo/bandeja/cdx/actualizarestatussolicitud",
          params
          
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        }).finally(() => (this.funcionExtraBandeja(idEstatusSolicitud)));
    },
    funcionExtraBandeja(idEstatusSolicitud) {
      this.$emit("_funcionExtra", idEstatusSolicitud);
    },
  },
};
</script>
